import { createSelector } from "reselect"
import { initialState } from "./reducer"
import { selectDimensionByDivisionDomain } from "../DimensionByDivision/selectors"

/**
 * Direct selector to the divisionAnalysis state domain
 */

const selectDivisionAnalysisDomain = (state) =>
  state.get("divisionAnalysis", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoading = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDivisions = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectDimensions = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectShowHistory = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("showHistory")
  )

export const makeSelectSwitchMoreDimensions = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("switchMoreDimensions")
  )

export const makeSelectDivisionsDrillDown = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("divisionsDrillDown")
  )

export const makeSelectMetric = () =>
  createSelector(selectDivisionAnalysisDomain, (state) => state.get("metric"))

export const makeSelectLevels = () =>
  createSelector(selectDivisionAnalysisDomain, (state) => state.get("levels"))

export const makeSelectGraphicBars = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("graphicBars")
  )

export const makeSelectIsLoadingGraphicBars = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("isLoadingGraphicBars")
  )

export const makeSelectDivisionWithEngagement = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("divisionsWithEngagement")
  )

export const makeSelectMeasureRangeColor = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectMeasure = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("metricsTotalLabel")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("measureInfo")
  )

export const makeSelectIdMeasure = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("idMeasure")
  )

export const makeSelectIsEngagement = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("isEngagement")
  )

export const makeSelectIsEngagementOnly = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("isEngagementOnly")
  )

export const makeSelectIsLoadingDivision = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("isLoadingDivision")
  )

export const makeSelectIsLoadingDivEng = () =>
  createSelector(selectDivisionAnalysisDomain, (state) =>
    state.get("isLoadingDivEng")
  )

/**
 * Default selector used by DivisionAnalysis
 */

const makeSelectDivisionAnalysis = () =>
  createSelector(selectDivisionAnalysisDomain, (substate) => substate.toJS())

export default makeSelectDivisionAnalysis
export { selectDivisionAnalysisDomain }
